import _JSXStyle from "styled-jsx/style";
import { colors, elevations } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Card = _ref => {
  let {
    className,
    children,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["3454125090", [colors.white, elevations.e100]]]) + " " + (cx(className) || "")
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3454125090",
    dynamic: [colors.white, elevations.e100]
  }, ["div.__jsx-style-dynamic-selector{display:inline-block;position:relative;width:100%;height:100%;border-radius:3px;background:".concat(colors.white, ";box-shadow:").concat(elevations.e100, ";}")]));
};

Card.defaultProps = {
  dataTest: 'dhis2-uicore-card'
};
Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string
};
export { Card };